import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import mixpanel from 'mixpanel-browser';
import { Row } from 'hedron';
import { NavigationContentLink, NavigationContentLinkTitle } from '../../Links/Links';
import HoverBox from './styled/HoverBox';
import NavigationContentList from './styled/NavigationContentList';
import { HoverImage, HoverImageColumn } from './styled/HoverBoxImage';
import { pageMaxWidth } from '../../mediaQueries';
import { onSaleParam, newInParam, replaceSpaceWithDash } from '../../../helpers/helpers';
import TrackingEvents from '../../../common/models/TrackingEvents';
import withCountryCode from '../../RoutesHoc/RoutesHoc';

class NavigationContent extends Component {
  constructor(props) {
    super(props);

    this.buildUrlSalesNewIn = this.buildUrlSalesNewIn.bind(this);
  }

  componentDidMount() {
    const { values, department } = this.props;
    mixpanel.track_links(`#nav-title-sublink-${replaceSpaceWithDash(values.name)}`, TrackingEvents.categorySelected(), {
      department,
      category: values.name.toLowerCase()
    });
    values.children.map(curr => {
      mixpanel.track_links(`#nav-sublink-${curr.name.replace(/\s/g, '-')}`, TrackingEvents.categorySelected(), {
        department,
        category: values.name.toLowerCase(),
        subcategory: curr.name.toLowerCase()
      });
    });
  }

  // TODO: all this logic to manipulate urls should be refactor after homepages-config tools will be enhanced
  buildUrlSalesNewIn(url, sales) {
    if (url.includes('?')) {
      return url.replace(/\?.*$/g, `?${sales ? onSaleParam : newInParam}`);
    }

    return `${url}?${sales ? onSaleParam : newInParam}`;
  }

  render() {
    const {
      applyNewInSales,
      values,
      hoverLeftImg,
      hoverRightImg,
      buildUrlWithCountry,
      newIn = false,
      sales = false
    } = this.props;
    const hoverLeftHref = applyNewInSales
      ? buildUrlWithCountry(`${values.url}?${newInParam}`)
      : buildUrlWithCountry(`${this.buildUrlSalesNewIn(hoverLeftImg.a_href, sales)}`);
    const hoverRightHref = applyNewInSales
      ? buildUrlWithCountry(`${values.url}?${onSaleParam}`)
      : buildUrlWithCountry(`${this.buildUrlSalesNewIn(hoverRightImg.a_href, sales)}`);

    let queryParam = '';
    let title = null;

    if (sales) {
      title = 'Sale';
      queryParam = `?${onSaleParam}`;
    }

    if (newIn) {
      title = 'New In';
      queryParam = `?${newInParam}`;
    }

    return (
      <Fragment>
        <HoverBox>
          <div
            style={{
              display: 'flex',
              maxWidth: pageMaxWidth,
              margin: '0 auto',
              justifyContent: 'space-between'
            }}
          >
            <div style={{ paddingTop: '20px' }}>
              <NavigationContentLinkTitle
                color={sales ? '#FF0000' : 'black'}
                id={`nav-title-sublink-${replaceSpaceWithDash(values.name)}`}
                href={buildUrlWithCountry(`${values.url}/${queryParam}`)}
              >
                {title || values.name}
              </NavigationContentLinkTitle>
              <NavigationContentList>
                {values.children.map(subCat => (
                  <Fragment>
                    {subCat.name.toLowerCase() !== 'designers' && (
                      <NavigationContentLink
                        id={`nav-sublink-${subCat.name.replace(/\s/g, '-')}`}
                        href={buildUrlWithCountry(`${subCat.url}/${queryParam}`)}
                        key={subCat.name}
                      >
                        {subCat.name}
                      </NavigationContentLink>
                    )}
                  </Fragment>
                ))}
              </NavigationContentList>
            </div>
            <div>
              <Row justifyContent="flex-end">
                {hoverLeftImg && hoverRightImg && (
                  <Fragment>
                    <HoverImageColumn>
                      <NavigationContentLinkTitle color="#000" href={hoverLeftHref}>
                        {hoverLeftImg.heading}
                      </NavigationContentLinkTitle>
                      <a href={hoverLeftHref}>
                        <HoverImage alt={hoverLeftImg.alt} title={hoverLeftImg.name} src={hoverLeftImg.image} />
                      </a>
                    </HoverImageColumn>
                    <HoverImageColumn marginLeft="59px">
                      <NavigationContentLinkTitle href={hoverRightHref} color={!sales && !newIn ? '#FF0000' : 'black'}>
                        {hoverRightImg.heading}
                      </NavigationContentLinkTitle>
                      <a href={hoverRightHref}>
                        <HoverImage alt={hoverRightImg.alt} title={hoverRightImg.name} src={hoverRightImg.image} />
                      </a>
                    </HoverImageColumn>
                  </Fragment>
                )}
              </Row>
            </div>
          </div>
        </HoverBox>
      </Fragment>
    );
  }
}

NavigationContent.propTypes = {
  values: PropTypes.object.isRequired,
  applyNewInSales: PropTypes.bool,
  department: PropTypes.string,
  hoverLeftImg: PropTypes.objectOf(
    PropTypes.shape({
      a_href: PropTypes.string,
      alt: PropTypes.string,
      folder: PropTypes.string,
      heading: PropTypes.string,
      image: PropTypes.string,
      img_name: PropTypes.string,
      md5: PropTypes.string,
      title: PropTypes.string
    })
  ),
  hoverRightImg: PropTypes.objectOf(
    PropTypes.shape({
      a_href: PropTypes.string,
      alt: PropTypes.string,
      folder: PropTypes.string,
      heading: PropTypes.string,
      image: PropTypes.string,
      img_name: PropTypes.string,
      md5: PropTypes.string,
      title: PropTypes.string
    })
  ),
  sales: PropTypes.bool,
  newIn: PropTypes.bool
};

export default withCountryCode(NavigationContent);
